import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    filtroPedidos: null
  },
  getters: {
    user (state) {
      return state.user;
    },
    token (state) {
      return state.token;
    },
    filtroPedidos (state) {
      return state.filtroPedidos;
    },
  },
  actions: {
    setUser ({ commit }, value) {
      commit('setUser', value);
    },
    setToken ({ commit }, value) {
      commit('setToken', value);
    },
    setFiltroPedidos ({ commit }, value) {
      commit('setFiltroPedidos', value);
    },
  },
  mutations: {
    setUser (state, value) {
      state.user = value;
    },
    setToken (state, value) {
      state.token = value;
    },
    setFiltroPedidos (state, value) {
      state.filtroPedidos = value;
    }
  },
  plugins: [
    createPersistedState(),
  ],
  strict: process.env.NODE_ENV !== 'production'
});


// WEBPACK FOOTER //
// ./src/store/index.js